export default
    {
        path: "/pass/wita/getInfo/getUrl",
        component: () => import('../view/pass/pass.vue'),
        children: [
            
            
        ]

    }



// WEBPACK FOOTER //
// ./src/router/passRouter.js